"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapSeries(values, fn) {
    var results = [];
    return values.reduce(function (p, v) {
        return p.then(function () { return fn(v); }).then(function (r) {
            results.push(r);
            return results;
        });
    }, Promise.resolve());
}
exports.mapSeries = mapSeries;
//# sourceMappingURL=mapSeries.js.map